import * as React from 'react'

import { Box, List, Text } from '@factorialco/deprecated-design-system'

import { observer } from 'mobx-react'

import i18n from 'modules/core/lib/i18n'

import { DimensionWithEmployeeAssignment } from 'modules/finance/hooks/useEmployeeDimensionsAssignments'

interface Props {
  dimensions: DimensionWithEmployeeAssignment[]
}

const EmployeeDimensionsList = ({ dimensions }: Props) => {
  return (
    <List>
      {dimensions.map((dimension) => (
        <List.Item key={dimension.id}>
          <Box flexDirection="row" width="full" justifyContent="spaceBetween" gap="s24">
            <Box>
              <Text.Normal color="grey1000">{dimension.name}</Text.Normal>
            </Box>
            <Box gap="s2" flexDirection="column" textAlign="right" flexGrow>
              {dimension.type == 'single-value' && dimension.assignmentValue ? (
                <Text color="grey800" weight="medium" size="300">
                  {dimension.assignmentValue.name}
                </Text>
              ) : dimension.type == 'multiple-value' && dimension.assignments.length > 0 ? (
                dimension.assignments.map((assignment) => (
                  <Text key={assignment.name} color="grey800" weight="medium" size="300">
                    {`${assignment.name} (${(assignment.percentage * 100).toFixed(2)}%)`}
                  </Text>
                ))
              ) : (
                <Text.Normal color="grey700">
                  {i18n.t('finance.employee_dimensions_info.not_assigned')}
                </Text.Normal>
              )}
            </Box>
          </Box>
        </List.Item>
      ))}
    </List>
  )
}

export default observer(EmployeeDimensionsList)
